import React from "react";
import _ from "underscore"
import Currency from "../../common/Currency";

const PopularBags = React.memo(({popularBags}) => {
    return (
        <div className="search-menu-old__recently-viewed-list">
            {_.map(popularBags, (popularBag, idx) => {
                return (
                    <PopularBagItem key={idx} popularBag={popularBag}/>
                )
            })}
        </div>
    )
})

const PopularBagItem = React.memo(({popularBag}) => {
    return (
        <a
            href={popularBag.product_url}
            className="search-menu-old__recently-viewed-item"
        >
            <div className="search-menu-old__recently-viewed-img">
                <img
                    src={popularBag.image_url}
                    alt={popularBag.title}
                />
                {popularBag.status === 'sold' &&
                    <div className="corner-ribbon top-left">Sold</div>
                }
            </div>
            <div className="search-menu-old__recently-viewed-details">
                <div className="search-menu-old__recently-viewed-top">
                    <span className="search-menu-old__recently-viewed-designer">{popularBag.designer}</span>
                    <span className="search-menu-old__recently-viewed-title">{popularBag.title}</span>
                </div>
                <div className="search-menu-old__recently-viewed-bottom">
                    <Currency value={popularBag.price} className="search-menu-old__recently-viewed-price"/>
                    <div className="search-menu-old__recently-viewed-condition">
                        <span className="search-menu-old__recently-viewed-condition-label">Condition: </span>
                        <span className="search-menu-old__recently-viewed-condition-value">{popularBag.condition}</span>
                    </div>
                </div>
            </div>
        </a>
    )
})

export default PopularBags;